// src/services/weatherService.ts
import { apiClient } from './apiConfig'
import { WeatherData } from '../types'

export const getWeatherForecast = async (
  start_time: string,
  stop_time: string
): Promise<WeatherData[]> => {
  if (!start_time || !stop_time) {
    throw new Error('start_time and stop_time are required')
  }
//   if (start_time.length > 10) {
//     start_time = start_time.slice(0, 10)
//   }
//   if (stop_time.length > 10) {
//     stop_time = stop_time.slice(0, 10)
//   }
  // replace the T with a space and remove the miliseconds and Z
    start_time = start_time.replace('T', ' ').replace(/\.\d+Z/, '')
    stop_time = stop_time.replace('T', ' ').replace(/\.\d+Z/, '')
  const response = await apiClient.get<WeatherData[]>(
    `/get-forecast?start_time=${start_time}&stop_time=${stop_time}`
  )
  return response.data
}
